export const BASE_URL = `${process.env.REACT_APP_BACK_END_URL}`

export const PROFILE = `${BASE_URL}/profile`
export const VERIFICATION = `${BASE_URL}/verify`
export const DETECTION = `${BASE_URL}/detect`
